import { createRoute, useParams } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { TeacherProfileEditor } from "@/features/academy/components/people/teacher-profile-editor";

function AcademyTeacherEditorPage() {
  const params = useParams({ from: "/u/$u/academy/teachers/$userId" });
  return <TeacherProfileEditor userId={params().userId} />;
}

export const academyTeacherEditorRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/academy/teachers/$userId",
  component: AcademyTeacherEditorPage,
});
